import React, { useState, useEffect } from "react";
import { Modal, Button, FilePicker, } from "@veneer/core";
import { authenticationService } from "../../../services/context/AuthService";
import { useTranslation } from "react-i18next";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";

const connectApi = new ConnectAPI();
function RunlengthUpload({onShowModal, confirmationFunction,onCloseModal,showmodalagin}) {
    const [ShowModal, setShowModal] = useState(onShowModal);
    const { t, i18n } = useTranslation();
    const [FileGcp,setFileGcp]=useState(null);
    const [FileLp,setFileLp]=useState(null);
    const [loadingbtn,setloadingbtn]=useState(false);
    function handleChangeGCP(event) {
        setFileGcp(event.target.files[0]);

    }
    function handleChangelp(event){
        setFileLp(event.target.files[0]);
    }
    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'css-la566w-padding-Button',
          cancelButton: 'css-k95t6a-padding-Button'
        },
        buttonsStyling: false
      })
    function submit(){
        setloadingbtn(true);
        let data = new FormData();
        data.append("FileGsp", FileGcp);
        data.append("FileLp", FileLp);
        data.append("confirm","no");
        connectApi.post(
            "api/Channels/RunlengthUpload",
            data,
            handleReloadData
        ).catch((error) => {
            if(error?.response?.status==512){
                confirmationFunction();
                setloadingbtn(false);
                setFileGcp(null);
                setFileLp(null);
                swalWithBootstrapButtons.fire({
                    title: "Warning " + error?.response?.status,
                    html: error?.response?.data+", ",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Upload files',
                    cancelButtonText:'Return and change data',
                  }).then((result) => {
                    if (result.isConfirmed) {
                        showmodalagin();
                        setloadingbtn(true);
                        data.delete("confirm");
                        data.append("confirm","yes");
                        connectApi
                        .post(
                            "api/Channels/RunlengthUpload",
                            data,
                            handleReloadData
                        )

                    }
                  })
            }else{
                setloadingbtn(false);
                confirmationFunction();
                Swal.fire(
                    "Error " ,
                    error?.response?.data,
                    "error"
                );
            }

            
        });
    }
    const handleReloadData = (status,data) => {
        if (status==200){
            setloadingbtn(false);
            setFileGcp(null);
            setFileLp(null);
            confirmationFunction();
        }else{
            loadingbtn(false);
            Swal.fire(
                "Error " + data.status,
                data.data,
                "error"
            );
        }
    }
    return (
        <>            
            <Modal
                id="regular-modal"
                onClose={() => { onCloseModal(); }}
                show={onShowModal}
                css={{
                    '.vn-modal--content': {
                        width: "800px !important"
                    },
                  }}
                title="Run Length Program"
            >
                <label> GCP File </label>
                <FilePicker
                     id="gcpfile"
                     accept=".xlsx,.xls"
                     onChange={handleChangeGCP}
                     label="GCP File"
                />
                <br/>
                <label>L&P File</label>
                <FilePicker
                     id="lpfile"
                     accept=".xlsx,.xls"
                     onChange={handleChangelp}
                     label="L&P File"
                />
                <br/>
                <Button
                        loading={loadingbtn}
                        onClick={submit}
                        >{t("send")}</Button>
            </Modal>

            </>
    );
}
export default RunlengthUpload;